var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Sortable from 'sortablejs';
import Header from "./components/AddHeader.vue";
import PurSortingService from "../../api/PurSortingService";
import GLOBAL_VUE from '../../globalVue';
import { Loading } from 'element-ui';
import { UrlHelper } from '../../helper/UrlWrapper';
import { numSub } from "../../helper/calucate";
import { mapGetters } from 'vuex';
import TableHeaderToolTip from '../../common/components/TableHeaderToolTip';
var isSaveRequesting = false;
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["Submit"] = 1] = "Submit";
    ESaveType[ESaveType["Save"] = 2] = "Save";
})(ESaveType || (ESaveType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 330;
        _this.data = [];
        _this.formData = {
            order_code: "",
            business_info: [],
            sorting_schedule: "",
            organ_name: "",
            purchase_order_order: [],
            order_icomment: "",
            depot_name: "",
            item_num: "",
            goods_detail: [],
            is_has_scm_goods: 0,
        };
        _this.orderid = '';
        _this.dialogTableEditVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        return _this;
    }
    default_1.prototype.mounted = function () {
        if (this.orderid) {
            this.getDetail();
        }
    };
    default_1.prototype.created = function () {
        this.service = PurSortingService.getInstance();
    };
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.selected = function (row, index) {
        if (row.is_split_order == 1) {
            return true;
        }
        else {
            return false;
        }
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid
        };
        this.service.getUpdateDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.formData = data;
            if (_this.formData.goods_detail.length > 0) {
                _this.formData.goods_detail.forEach(function (element) {
                    element.old_sorting_stock = element.sorting_stock;
                });
            }
            if (_this.formData.goods_detail.length > 1) {
                _this.$nextTick(function () {
                    _this.setSort();
                });
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.importData = function () {
        this.dialogTableEditVisible = true;
    };
    default_1.prototype.exportTable = function () {
        var url = 'supplierclientapi/sorting/download_template?order_id=' + this.orderid;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(["_trackEvent", '编辑分拣单', '分拣导出', '分拣导出']);
    };
    default_1.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (fileType == "xlsx" || fileType == "xls") {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error("文件只能是xlsx或xls");
        return false;
    };
    default_1.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            this.getDetail();
            var url = "supplierclientapi/sorting/export_error?import_id=" + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            window._czc.push(["_trackEvent", '编辑分拣单', '分拣导入', '分拣导入']);
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    default_1.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    default_1.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    default_1.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    default_1.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    default_1.prototype.saveSingle = function (row, type) {
        var _this = this;
        var timer = setTimeout(function () {
            clearTimeout(timer);
            if (isSaveRequesting)
                return;
            var order_detail_id = row.order_detail_id, old_sorting_stock = row.old_sorting_stock, sorting_stock = row.sorting_stock, out_depot_id = row.out_depot_id, order_detail_icomment = row.order_detail_icomment, print_num = row.print_num;
            if (type === 'sorting_stock') {
                row.diff = numSub(row.sorting_stock, row.purchase_stock);
            }
            var params = {
                order_id: _this.orderid,
                data: JSON.stringify([{
                        order_detail_id: order_detail_id,
                        old_sorting_stock: old_sorting_stock,
                        sorting_stock: sorting_stock,
                        out_depot_id: out_depot_id,
                        order_detail_icomment: order_detail_icomment,
                        print_num: print_num
                    }]),
                order_icomment: _this.formData.order_icomment
            };
            _this.service.editSave(params).then(function (res) {
                window._czc.push(["_trackEvent", '编辑分拣单', '保存', '保存']);
                row.old_sorting_stock = row.sorting_stock;
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }, 500);
    };
    default_1.prototype.save = function () {
        var _this = this;
        isSaveRequesting = true;
        var formData = this.formData;
        var params = {
            order_id: this.orderid,
            data: JSON.stringify(formData.goods_detail.map(function (v, vIndex) {
                return {
                    order_detail_id: v.order_detail_id,
                    sort: vIndex + 1,
                    old_sorting_stock: v.old_sorting_stock,
                    sorting_stock: v.sorting_stock,
                    out_depot_id: v.out_depot_id,
                    order_detail_icomment: v.order_detail_icomment,
                    print_num: v.print_num,
                };
            })),
            order_icomment: formData.order_icomment
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.editSave(params).then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            var timer = setTimeout(function () {
                clearTimeout(timer);
                GLOBAL_VUE.$emit("closeTab", _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
                window._czc.push(["_trackEvent", '编辑分拣单', '保存', '保存']);
                isSaveRequesting = false;
            }, 500);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
            isSaveRequesting = false;
        });
    };
    default_1.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        var ref = this.$refs.dragTable;
        this.formData.goods_detail = ref.tableData;
    };
    default_1.prototype.splitNote = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品后再进行拆分');
            return;
        }
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426\u5C06\u9009\u4E2D\u8D27\u54C1\u751F\u6210\u65B0\u7684\u5206\u62E3\u5355\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
        }).then(function (res) {
            if (res) {
                var data = _this.selections;
                var params = {
                    order_id: _this.orderid,
                    data: JSON.stringify(data.map(function (v, vIndex) {
                        return {
                            order_detail_id: v.order_detail_id,
                            sort: vIndex + 1,
                            old_sorting_stock: v.old_sorting_stock,
                            sorting_stock: v.sorting_stock,
                            out_depot_id: v.out_depot_id,
                            order_detail_icomment: v.order_detail_icomment,
                            print_num: v.print_num,
                        };
                    })),
                    order_icomment: _this.formData.order_icomment
                };
                _this.service.splitNote(params).then(function (res) {
                    if (res.data.code == 0) {
                        _this.$message.success('操作成功');
                        var timer_1 = setTimeout(function () {
                            clearTimeout(timer_1);
                            GLOBAL_VUE.$emit("closeTab", _this);
                            _this.opener.getList();
                        }, 500);
                        return;
                    }
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.setSort = function () {
        var _this = this;
        var el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
        this.sortable = Sortable.create(el, {
            ghostClass: 'sortable-ghost',
            handle: ".row-btn-move-y__handle",
            setData: function (dataTransfer) {
                dataTransfer.setData('Text', '');
            },
            onEnd: function (evt) {
                var targetRow = _this.formData.goods_detail.splice(evt.oldIndex, 1)[0];
                _this.formData.goods_detail.splice(evt.newIndex, 0, targetRow);
            }
        });
    };
    default_1.prototype.getAmountScale = function (row) {
        var businessId = row.business_id;
        return this.$store.getters.getBusinessConfig(businessId, 'amount_scale', '4');
    };
    default_1.prototype.handleInput = function (row, value) {
        if (value === '')
            return;
        var scale = this.getAmountScale(row);
        var pointIndex = value.toString().indexOf('.');
        if (pointIndex > -1) {
            row.sorting_stock = value.toString().slice(0, pointIndex + Number(scale) + 1);
        }
    };
    default_1 = __decorate([
        Component({
            components: {
                'add-header': Header,
                TableHeaderToolTip: TableHeaderToolTip
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "销售系数*订货合计",
                            placement: "bottom"
                        }
                    }, '待领货');
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
